export default __webpack_public_path__ + "media/images/new-solicitors-image-bb22cc3a5bf64038b591e098ce2288d5.png";